import axios from 'axios';

export const INVALID_TOKEN = 'token_not_valid';

export const callApiNew = async <Response>(apiConfig: CallAPIConfig): Promise<Response> => {
  const initialConfigObject: Partial<CallAPIConfig> = {
    method: 'GET',
    params: {},
    body: {},
    headers: {},
  };

  const { endpoint, method, headers, params, body } = {
    ...initialConfigObject,
    ...apiConfig,
  };

  const mandatoryHeaders = {
    'Content-Type': 'application/json',
    'bludot-app-name': 'community-rewards',
    Authorization: '',
  };

  const requestHeaders = {
    ...mandatoryHeaders,
    ...headers,
  };

  const config = {
    method,
    params,
    headers: requestHeaders,
    data: body,
    url: process.env.REACT_APP_SERVER_URL + endpoint,
  };

  return axios
    .request(config)
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
